import styles from './MonitorPerformanceChart.module.scss'

// list of color defined for each steps
export const stepColors = [
  styles.step0,
  styles.step1,
  styles.step2,
  styles.step3,
  styles.step4,
  styles.step5,
  styles.step6,
  styles.step7,
  styles.step8,
  styles.step9,
  styles.step10,
  styles.step11,
  styles.step12,
  styles.step13,
  styles.step14,
  styles.step15,
  styles.step16,
  styles.step17,
  styles.step18,
  styles.step19,
  styles.step20,
  styles.step21,
  styles.step22,
  styles.step23,
  styles.step24,
  styles.step25,
  styles.step26
] as const
